module.exports = [{"source":"/showroom","destination":"/work","permanent":true}];